import { FULFILLMENT_TYPE } from '../constants/status';
export var createCancellationItems = function (orderDetailsData, cancelInfo) {
    var lineCancelIdsAndQtys = cancelInfo.lineCancelIdsAndQtys, fulfillmentTypeForCMS = cancelInfo.fulfillmentTypeForCMS, bodfsStoreNumber = cancelInfo.bodfsStoreNumber, bossStoreNumber = cancelInfo.bossStoreNumber, workOrderNumber = cancelInfo.workOrderNumber, isPostRemorseCancel = cancelInfo.isPostRemorseCancel, zipCode = cancelInfo.zipCode;
    if (isPostRemorseCancel) {
        var cancellationItems_1 = [];
        var postRemorseFulfillmentGroups = orderDetailsData.fulfillmentGroups;
        postRemorseFulfillmentGroups.forEach(function (postRemorseFulfillmentGroup) {
            var _a;
            var postRemorseFulfillmentType = postRemorseFulfillmentGroup.fulfillmentType === FULFILLMENT_TYPE.STH
                ? 'STH'
                : 'BOSS';
            (_a = postRemorseFulfillmentGroup.lineItems) === null || _a === void 0 ? void 0 : _a.forEach(function (lineItem) {
                var _a, _b, _c, _d, _e, _f;
                var currentQuantity = lineItem.currentQuantity
                    ? lineItem.currentQuantity
                    : lineItem.quantity;
                var storeNumber;
                var isBossPostShipped = postRemorseFulfillmentType === 'BOSS'
                    ? lineItem.isBossPostShipped
                    : undefined;
                if (postRemorseFulfillmentType === 'BOSS' &&
                    ((_b = (_a = postRemorseFulfillmentGroup === null || postRemorseFulfillmentGroup === void 0 ? void 0 : postRemorseFulfillmentGroup.storePickup) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.number)) {
                    storeNumber = (_d = (_c = postRemorseFulfillmentGroup.storePickup) === null || _c === void 0 ? void 0 : _c.store) === null || _d === void 0 ? void 0 : _d.number;
                }
                else if (postRemorseFulfillmentType === 'STH') {
                    storeNumber = undefined;
                }
                else if ((lineItem === null || lineItem === void 0 ? void 0 : lineItem.storeNumber) === undefined) {
                    storeNumber = '8119'; // if storeNumber is undefined somehow, falls back to set as originating as online order duplicating safeguards from previous experience
                }
                else {
                    storeNumber = lineItem.storeNumber.toString();
                }
                cancellationItems_1.push({
                    imageUrl: lineItem.imageUrl,
                    brandName: lineItem.brandName,
                    description: lineItem.description,
                    lineId: lineItem.lineId,
                    canceledQuantity: currentQuantity,
                    maxCancelQuantity: currentQuantity,
                    unitPrice: lineItem.unitPrice,
                    fulfillmentType: postRemorseFulfillmentType,
                    skuNumber: (_e = lineItem === null || lineItem === void 0 ? void 0 : lineItem.skuNumber) === null || _e === void 0 ? void 0 : _e.toString(),
                    storeNumber: storeNumber,
                    isPRCR: isPostRemorseCancel,
                    omsId: (_f = lineItem === null || lineItem === void 0 ? void 0 : lineItem.omsId) === null || _f === void 0 ? void 0 : _f.toString(),
                    isDFCSourced: lineItem.isDFCSourced,
                    fulfillmentVendorNumber: lineItem.isDFCSourced
                        ? lineItem.fulfillmentVendorNumber
                        : undefined,
                    productType: lineItem === null || lineItem === void 0 ? void 0 : lineItem.productType,
                    lineParentId: lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineParentId,
                    lineComboType: lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineComboType,
                    isBossPostShipped: isBossPostShipped,
                });
            });
        });
        return cancellationItems_1;
    }
    var lineItems = orderDetailsData.fulfillmentGroups
        .filter(function (groups) { return groups.lineItems !== undefined; })
        .filter(function (groups) {
        var _a, _b, _c, _d;
        if (fulfillmentTypeForCMS === 'BODFS' ||
            fulfillmentTypeForCMS === 'DFS') {
            return lineCancelIdsAndQtys === null || lineCancelIdsAndQtys === void 0 ? void 0 : lineCancelIdsAndQtys.map(function (lineCancelIdAndQty) { return lineCancelIdAndQty.workOrderNumber; }).includes((_d = (_c = (_b = (_a = groups === null || groups === void 0 ? void 0 : groups.bodfsDeliveryAndHandling) === null || _a === void 0 ? void 0 : _a.bodfsDeliveries) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.workOrderNo) !== null && _d !== void 0 ? _d : '');
        }
        return groups;
    })
        .map(function (fulfillmentGroup) { var _a; return (_a = fulfillmentGroup.lineItems) === null || _a === void 0 ? void 0 : _a.map(function (lineItem) { return lineItem; }); })
        .flat()
        .filter(function (lineItem) {
        var _a;
        return lineCancelIdsAndQtys === null || lineCancelIdsAndQtys === void 0 ? void 0 : lineCancelIdsAndQtys.map(function (lineCancelIdAndQty) { return lineCancelIdAndQty.lineId; }).includes((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineId) !== null && _a !== void 0 ? _a : '');
    });
    var findCanceledQty = function (lineId) {
        var _a;
        var cancelQty = (_a = lineCancelIdsAndQtys === null || lineCancelIdsAndQtys === void 0 ? void 0 : lineCancelIdsAndQtys.find(function (lineCancelIdAndQty) { return (lineCancelIdAndQty === null || lineCancelIdAndQty === void 0 ? void 0 : lineCancelIdAndQty.lineId) === lineId; })) === null || _a === void 0 ? void 0 : _a.canceledQuantity;
        return cancelQty || 0;
    };
    var determineStoreNumber = function (lineItem) {
        var _a;
        if (fulfillmentTypeForCMS === 'STH') {
            return undefined;
        }
        if (fulfillmentTypeForCMS === 'BODFS' && bodfsStoreNumber !== '') {
            return bodfsStoreNumber;
        }
        if (fulfillmentTypeForCMS === 'BOSS' && bossStoreNumber !== '') {
            return bossStoreNumber;
        }
        return (lineItem === null || lineItem === void 0 ? void 0 : lineItem.storeNumber) ? (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.storeNumber) === null || _a === void 0 ? void 0 : _a.toString() : '8119';
    };
    return lineItems === null || lineItems === void 0 ? void 0 : lineItems.map(function (lineItem) {
        var _a, _b, _c, _d, _e, _f;
        return {
            imageUrl: lineItem === null || lineItem === void 0 ? void 0 : lineItem.imageUrl,
            brandName: lineItem === null || lineItem === void 0 ? void 0 : lineItem.brandName,
            description: lineItem === null || lineItem === void 0 ? void 0 : lineItem.description,
            lineId: lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineId,
            canceledQuantity: findCanceledQty((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineId) !== null && _a !== void 0 ? _a : 0),
            maxCancelQuantity: (_c = (_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.workOrderFulfilledQty) !== null && _b !== void 0 ? _b : lineItem === null || lineItem === void 0 ? void 0 : lineItem.currentQuantity) !== null && _c !== void 0 ? _c : lineItem === null || lineItem === void 0 ? void 0 : lineItem.quantity,
            unitPrice: lineItem === null || lineItem === void 0 ? void 0 : lineItem.unitPrice,
            fulfillmentType: fulfillmentTypeForCMS,
            skuNumber: (_d = lineItem === null || lineItem === void 0 ? void 0 : lineItem.skuNumber) === null || _d === void 0 ? void 0 : _d.toString(),
            storeNumber: determineStoreNumber(lineItem),
            // superSku for analytics
            superSku: (lineItem === null || lineItem === void 0 ? void 0 : lineItem.omsId) ? (_e = lineItem === null || lineItem === void 0 ? void 0 : lineItem.omsId) === null || _e === void 0 ? void 0 : _e.toString() : undefined,
            zipCode: zipCode,
            isPRCR: fulfillmentTypeForCMS === 'STH' || fulfillmentTypeForCMS === 'BOSS'
                ? isPostRemorseCancel
                : undefined,
            omsId: isPostRemorseCancel ? (_f = lineItem === null || lineItem === void 0 ? void 0 : lineItem.omsId) === null || _f === void 0 ? void 0 : _f.toString() : undefined,
            isDFCSourced: isPostRemorseCancel ? lineItem === null || lineItem === void 0 ? void 0 : lineItem.isDFCSourced : undefined,
            workOrderNumber: workOrderNumber,
            productType: lineItem === null || lineItem === void 0 ? void 0 : lineItem.productType,
            lineParentId: lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineParentId,
            lineComboType: lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineComboType,
        };
    });
};
